// modals alerts

export const LOAD_TOKEN = "LOAD_TOKEN";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGOUT = "LOGOUT";
export const AUTH = "AUTH";

export const SHOW_SITE_LOADER = "SHOW_SITE_LOADER";
export const HIDE_SITE_LOADER = "HIDE_SITE_LOADER";

export const LOAD_Fullfillment_TOKEN = "LOAD_Fullfillment_TOKEN";
